import apiClient from '../apiClient';

async function create(commentaire) {
    return apiClient.post('gestion_commentaire', commentaire);
}

const commentairesActions = { create };

export default commentairesActions;
